app.service('orderPath', function (broker, console, pageConfig) {
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$('body').on('click', '.js-next-step', function () {
				console.log('Kliknięcie dalej z nagłówka na kroku:' + pageConfig.getData('order').pageType);
				broker.trigger('ORDER-NEXT-STEP');
			});
		}
	}
	function reload(stage) {
		let $self = $('#order-path');
		$self.addClass('is-sending');
		$.ajax({
			url: `/order-path.ltr?currentStage=${stage}`
		}).then(html => {
			$self.html($(html).filter('#order-path').html());
		}).always(() => {
			$self.removeClass('is-sending');
		})
	}
	return {
		init,
		reload
	};
});
